export default __webpack_public_path__ + "static/media/rabbit.779080bc.png";